<template>
  <KfDesktopMobile>
    <template #appGrid>
      <MobileGroupDesktop/>
    </template>
  </KfDesktopMobile>
</template>
<script>

import MobileGroupDesktop from "@/views/mobile/MobileGroupDesktop.vue";

const messages = {
  zhCn: {
    badge_error: 'Badge消息加载失败，{msg}',
  },
  zhTw: {
    badge_error: 'Badge消息加載失敗，{msg}',
  },
  en: {
    badge_error: 'Badge message failed to load, {msg}',
  }
}

export default {
  name: 'DesktopMobile',
  components: {MobileGroupDesktop},
  i18n: {messages},
  data() {
    return {
      pollingTimer: null
    }
  },
  async created() {
    this.$store.state.core.mobile = true;
    await this.loadConfig()

    let user = await this.$http('sysUserService.getCurrentUser');
    this.$store.commit('core/CURRENT_USER_INIT', user)

    this.loadDefinition()
    this.getUserApps();

    let data = await this.$http('sysDictService.selectAll')
    this.$store.commit('core/INIT_DICT', data)
  },
  methods: {
    polling() {
      let pollingTime = parseInt(this.$store.getters['core/getConfig']('polling_time')) || 0;
      if (pollingTime < 1 || this.pollingTimer) {
        return;
      }

      this.pollingTimer = setInterval(async () => {
        let dataKeys = this.$store.getters['core/getBadgeDataKeyList'];
        if (dataKeys.length == 0) {
          return;
        }

        this.$http('framePollingService.getPollingData', {data_keys: dataKeys}, false).then(data => {
          this.$store.commit('core/INIT_BADGE', data)
          /*let msg = this.$store.getters['core/getBadgeData']('one_un_send_msg');
          if (msg) {
            this.$notify.info({
              title: "收到新消息",
              message: msg.title,
              duration: 6000
            })
          }*/
        }, errMsg => {
          return this.$message.error(`Badge消息加载失败，${errMsg}`);
        })
      }, pollingTime * 1000)

    },
    async loadDefinition() {
      let data = await this.$http('frameUiService.loadMobileDefinition')
      this.$store.dispatch('core/initDefinition', data);
    },
    async loadConfig() {
      let data = await this.$http('sysConfigService.getWebConfig')
      this.$store.commit('core/INIT_SYS_CONFIG', data)
      this.$store.commit('wallpaper/INIT_CONFIG', data)
      document.title = this.$store.getters['core/getAppName']

      this.polling()
    },
    async getUserApps() {
      let data = await this.$http('frameUiService.getUserMobileApps');
      this.$store.commit('core/INIT_USER_APP', data)
    }

  },
  unmounted() {
    clearInterval(this.pollingTimer)
  }
};
</script>

<style lang="less" scoped>

</style>
